<app-facet-pills [hideDescription]="hideDescription()" [facets]="facets()" [selectedFacet]="selectedFacet()" (selected)="onFilter($event)"
  [withDescription]="withDescription()"></app-facet-pills>
